import Vue from "vue";
import Router from "vue-router";
import * as pbFunc from "@/assets/utils";
// import HelloWorld from '@/components/HelloWorld'

import index from "@/pages/index"; //首页
import automaticStation from "./automaticStation" //自动站类别
import dataStatistics from "./dataStatistics" //数据统计
import giveAnAlarm from "./giveAnAlarm" //报警管理
Vue.use(Router);
//重复点击路由会报错，解决方案
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
let router = new Router({
  routes: [{
      path: "/",
      name: "login",
      meta: {
        title: "登录",
      },
      component: resolve => require(["../pages/login.vue"], resolve)
      // component: HelloWorld
    },
    {
      path: "",
      name: "mains",
      redirect: "/index",
      meta: {
        requireAuth: true
      },
      component: resolve => require(["../pages/mains.vue"], resolve),

      children: [{
          path: "/index",
          name: "index",
          meta: {
            title: "首页",
            requireAuth: true
          },
          component: index
        },
        {
          path: "automaticStation",
          name: "automaticStation",
          meta: {
            title: "自动站",
            requireAuth: true
          },
          redirect: '/automaticStation/classify',
          component: resolve => require(["../pages/automaticStation/automaticStation.vue"], resolve),
          children: automaticStation
        }, {
          path: "dataStatistics",
          name: "dataStatistics",
          meta: {
            title: "数据统计",
            requireAuth: true
          },
          // redirect: '/dataStatistics/classify',
          component: resolve => require(["../pages/dataStatistics/dataStatistics.vue"], resolve),
          children: dataStatistics
        }, {
          path: "giveAnAlarm",
          name: "giveAnAlarm",
          meta: {
            title: "报警管理",
            requireAuth: true
          },
          // redirect: '/dataStatistics/classify',
          component: resolve => require(["../pages/giveAnAlarm/giveAnAlarm.vue"], resolve),
          children: giveAnAlarm
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  let routeName = to.meta.title || to.name;
  window.document.title = (routeName ? routeName : '');
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js